const WP = 'https://en.wikipedia.org/w/api.php';

const GENRE_RULES: [string, string[]][] = [
    ['Action',           ['action', 'martial arts', 'superhero', 'action-adventure']],
    ['Adventure',        ['adventure']],
    ['Animation',        ['animation', 'animated', 'anime']],
    ['Comedy',           ['comedy', 'comedies', 'sitcom', 'mockumentary', 'buddy film']],
    ['Crime',            ['crime', 'gangster', 'heist', 'mob film', 'noir', 'legal drama']],
    ['Documentary',      ['documentary', 'documentaries', 'docuseries', 'docudrama']],
    ['Drama',            ['drama']],
    ['Family',           ['family', 'children']],
    ['Fantasy',          ['fantasy', 'fairy tale', 'supernatural', 'mythology']],
    ['History',          ['history', 'historical', 'period', 'epic film', 'biographical']],
    ['Horror',           ['horror', 'slasher', 'monster', 'psychological horror', 'zombie']],
    ['Music',            ['music', 'musical', 'concert film']],
    ['Mystery',          ['mystery', 'detective', 'whodunit']],
    ['Romance',          ['romance', 'romantic']],
    ['Science Fiction',  ['science fiction', 'sci-fi', 'sci fi', 'science-fiction', 'dystopian', 'cyberpunk', 'space opera']],
    ['Thriller',         ['thriller', 'spy film', 'espionage', 'political thriller', 'psychological thriller']],
    ['War',              ['war film', 'war drama', 'military', 'war series', 'world war']],
    ['Western',          ['western']],
];

const SKIP_PHRASES = [
    'crime against', 'war crime', 'war effort', 'post-war', 'wartime',
    'music video', 'music school', 'music award', 'music critic',
    'family member', 'family life', 'family relationship',
    'action actor', 'action director', 'historical accuracy',
];

function extractGenres(categories: string[]): string[] {
    const genres = new Set<string>();
    for (const raw of categories) {
        const cat = raw.toLowerCase();
        if (SKIP_PHRASES.some(s => cat.includes(s))) continue;
        for (const [genre, keywords] of GENRE_RULES) {
            if (keywords.some(kw => cat.includes(kw))) genres.add(genre);
        }
    }
    return Array.from(genres);
}

async function wpGet(params: Record<string, string>): Promise<any> {
    const url = new URL(WP);
    url.searchParams.set('format', 'json');
    url.searchParams.set('origin', '*'); // required for browser CORS
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));
    const res = await fetch(url.toString());
    if (!res.ok) return null;
    return res.json();
}

export async function fetchGenresFromWikipedia(title: string, isTV: boolean): Promise<string[]> {
    if (!title.trim()) return [];

    // For TV: strip episode name after dash; for films: strip sequel numbers
    let searchTitle = title;
    if (isTV) {
        searchTitle = title.split(/\s+[-–—]\s+/)[0].replace(/^[""](.+)[""]$/, '$1').trim();
    } else {
        searchTitle = title
            .replace(/\s+(X{0,3})(IX|IV|V?I{0,3})$/i, '')
            .replace(/\s+\d+$/, '')
            .trim();
    }
    const query = isTV ? searchTitle : `${searchTitle} film`;

    const searchData = await wpGet({ action: 'query', list: 'search', srsearch: query, srnamespace: '0', srlimit: '5' });
    const results = searchData?.query?.search;
    if (!results?.length) return [];

    for (const result of results) {
        const catData = await wpGet({ action: 'query', pageids: String(result.pageid), prop: 'categories', cllimit: '500' });
        const page = catData?.query?.pages?.[String(result.pageid)];
        const cats: string[] = (page?.categories ?? []).map((c: any) => c.title.replace(/^Category:/i, ''));
        const genres = extractGenres(cats);
        if (genres.length > 0) return genres;
    }

    return [];
}
